import React from 'react';
import { useFormikContext, FormikValues } from 'formik';
import { Option } from "../../common/form/ElogSelect";

interface RouteInputProps {
    countries: Option[];
}

const RouteInput: React.FC<RouteInputProps> = ({ countries }) => {
    const formik = useFormikContext<FormikValues>();

    return (
        <>
            <tr>
                <th>Teekond*:</th>
                <td>
                    <div>
                        <select
                            name="startCountry"
                            value={formik.values.startCountry}
                            onChange={formik.handleChange}
                            className="text"
                        >
                            {countries.map((country) => (
                                <option key={country.value} value={country.value}>
                                    {country.label}
                                </option>
                            ))}
                        </select>
                        <input
                            name="startCity"
                            value={formik.values.startCity}
                            onChange={formik.handleChange}
                            type="text"
                            style={{ marginLeft: '3px' }}
                        />
                    </div>
                    <div>
                        <select
                            name="destinationCountry"
                            value={formik.values.destinationCountry}
                            onChange={formik.handleChange}
                            className="text"
                        >
                            {countries.map((country) => (
                                <option key={country.value} value={country.value}>
                                    {country.label}
                                </option>
                            ))}
                        </select>
                        <input
                            name="destinationCity"
                            value={formik.values.destinationCity}
                            onChange={formik.handleChange}
                            type="text"
                            style={{ marginLeft: '3px' }}
                        />
                    </div>
                </td>
            </tr>
        </>
    );
};

export default RouteInput;